import {
  ACTIVE_ACCOUNTS,
  ARPA_TREND,
  ARPU_TREND,
  CHURNED_PAYING_ACCOUNTS,
  CLV_TREND,
  ENGAGED_ACCOUNTS,
  NEW_PAYING_ACCOUNTS,
} from "./exampleData";
import { CHART_NEGATIVE } from "./chartTheme";
import AmountBarChart from "./AmountBarChart";
import MetricBarChart from "./MetricBarChart";

const count = (v: number) => `${v}`;

export const ClvChart = () => (
  <AmountBarChart
    caption="Projected customer lifetime value climbs from $5,200 to $6,000 — the total profit expected from a customer over the whole relationship. It sets the ceiling on what you can afford to spend to acquire one."
    data={CLV_TREND}
    seriesName="cLTV"
  />
);

export const ArpaChart = () => (
  <AmountBarChart
    caption="Average revenue per account edges up from $200 to $215 — total MRR divided by paying accounts. A rising ARPA means each customer is worth more, whether from up-tiering or better pricing."
    data={ARPA_TREND}
    seriesName="ARPA"
  />
);

export const ArpuChart = () => (
  <AmountBarChart
    caption="Average revenue per user climbs from $70 to $80 — total MRR divided by active users rather than accounts. It sits below ARPA because multi-seat accounts spread their revenue across several users."
    data={ARPU_TREND}
    seriesName="ARPU"
  />
);

export const ActiveAccountsChart = () => (
  <MetricBarChart
    caption="Active accounts grow from 140 to 172 — accounts with recent product activity, whether or not they pay. It is the leading indicator that sits upstream of retention and expansion."
    data={ACTIVE_ACCOUNTS}
    seriesName="Active accounts"
    format={count}
    domain={[0, "dataMax + 30"]}
    yWidth={36}
  />
);

export const EngagedAccountsChart = () => (
  <MetricBarChart
    caption="Engaged accounts climb from 60 to 86 — the highly-active subset that has built the product into a habit. These accounts retain and expand far better than merely active ones."
    data={ENGAGED_ACCOUNTS}
    seriesName="Engaged accounts"
    format={count}
    domain={[0, "dataMax + 20"]}
    yWidth={36}
  />
);

export const NewPayingAccountsChart = () => (
  <MetricBarChart
    caption="New paying accounts run 5–8 a month — accounts that started a paid subscription for the first time. Read it beside churned accounts to see whether the paying base is net growing."
    data={NEW_PAYING_ACCOUNTS}
    seriesName="New paying accounts"
    format={count}
    domain={[0, "dataMax + 3"]}
    yWidth={28}
  />
);

export const ChurnedPayingAccountsChart = () => (
  <MetricBarChart
    caption="Churned paying accounts run 3–4 a month — accounts that fully cancelled. Consistently below new paying accounts is what keeps the paying base growing."
    data={CHURNED_PAYING_ACCOUNTS}
    seriesName="Churned paying accounts"
    format={count}
    color={CHART_NEGATIVE}
    domain={[0, "dataMax + 3"]}
    yWidth={28}
  />
);
